import { Filter } from 'src/app/modules/core/store/models/filters.model';
import { IFieldFilterHandler, FieldFilterHandler } from 'src/app/modules/core/services/filter-runtime/field-handlers';

export class ImageFieldFilterHandler extends FieldFilterHandler implements IFieldFilterHandler {
  constructor() {
    super();
  }

  fieldMatchesFilter(value: any, filter: Filter): boolean {
    const handler = this.comparisonHandlers[filter.operator];
    if (!handler) {
      return true;
    }

    const doesMatch = handler(value, filter);

    return doesMatch;
  }
}
